!function($){
$(function() {
	var ScrollingButton = {
		init: function(options){
			var self = this;

			self.offcanvasButton = options.elementToggle;
			self.offcanvasButtonOpen = options.elementOpen;
			self.offcanvasButtonClose = options.elementClose;

			// if there's no sidebar, return false and remove buttons for toggling it
			if ($('.offcanvas-left').length == 0){
				self.offcanvasButton.remove();
				self.offcanvasButtonOpen.remove();
				self.offcanvasButtonClose.remove();
				return false;
			}

			self.UpdateButtonTop();

			self.scrollPos = $(document).scrollTop(),
			self.isButtonScrolling = false,
			self.isOffcanvasOpen = false;

			self.setUpEventHandlers();
		},
		setUpEventHandlers: function(){
			var self = this;

			// update the buttons top position every time the browser is narrower than 768px
			// to make sure it's not 0 because the button isn't showing on wider screens
			enquire.register("(max-width: 767px)", {
				match: function(){
					self.UpdateButtonTop();
				}
			});

			self.offcanvasButton.on("click", function(e){
				self.toggleOffCanvas();
			});
			self.offcanvasButtonClose.on("click", function(e){
				self.closeOffCanvas();
				self.positionToggleButton();
			});
			self.offcanvasButtonOpen.on("click", function(e){
				self.openOffCanvas();
			});

			$(window).on('scroll', function(){
				scrollPos = $(document).scrollTop()

				if( scrollPos > self.buttonTopDefault ){
					self.isButtonScrolling = true;
				}else{
					self.isButtonScrolling = false;
				}

				self.positionToggleButton();
			});	
		},
		openOffcanvas: function(){
			var self = this;
			$('.offcanvas-left').addClass("open");
			$('.collection-wrapper').addClass('pushed-by-offcanvas');
			self.isOffcanvasOpen = true;

			if(self.isButtonScrolling){
				self.positionToggleButtonHorizontally();
			}
		},
		closeOffCanvas: function(){
			var self = this;
			$('.offcanvas-left').removeClass("open");
			$('.collection-wrapper').removeClass('pushed-by-offcanvas');
			self.isOffcanvasOpen = false;
			self.positionToggleButton();
		},
		toggleOffCanvas: function(){
			var self = this;
			$('.offcanvas-left').toggleClass("open");
			$('.collection-wrapper').toggleClass('pushed-by-offcanvas');
			self.isOffcanvasOpen = !self.isOffcanvasOpen;
			if(!self.isOffcanvasOpen){
				self.positionToggleButton();
			}
		},
		positionToggleButtonHorizontally: function(){
			var self = this;
			if(self.isButtonScrolling){
				self.offcanvasButton.css({
					position: "fixed",
					left: "0",
				});
			}else{
				self.offcanvasButton.css({
					left: "",
				});
			}
		},
		positionToggleButtonVertically: function(){
			var self = this;
			if( self.isButtonScrolling ){
				self.offcanvasButton.css({
					top: "20px",
					position: "fixed"
				});
			}else{
				self.offcanvasButton.css({
					top: "",
					position: "relative"
				});
			}
		},
		positionToggleButton: function(){
			var self = this;
			self.positionToggleButtonVertically();
			self.positionToggleButtonHorizontally();
		},
		UpdateButtonTop: function(){
			var self = this;
			self.buttonTopDefault = self.offcanvasButton.offset().top;
		}
	};

	ScrollingButton.init({
		elementToggle: $('.offcanvas-toggle'),
		elementOpen: $('.offcanvas-open'),
		elementClose: $('.offcanvas-close')
	});
});
}(jQuery);